interface Props {
  name: string
  logo?: string
  setsWon: number
  timeoutsUsed: number
  maxTimeouts?: number
  side: 'home' | 'away'
  hasService: boolean
  setsDisplay?: 'dots' | 'number'
  className?: string
}

export default function TeamBlock({
  name, logo, setsWon, timeoutsUsed, maxTimeouts = 2,
  side, hasService, setsDisplay = 'dots', className = '',
}: Props) {
  const isRight = side === 'away'

  return (
    <div className={`flex flex-col ${isRight ? 'items-end' : 'items-start'} gap-1 ${className}`}>
      {/* Logo + Nome */}
      <div className={`flex items-center gap-2 ${isRight ? 'flex-row-reverse' : 'flex-row'}`}>
        {logo ? (
          <img
            src={logo}
            alt={name}
            className="w-8 h-8 object-contain rounded-full bg-white/10"
          />
        ) : (
          <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center">
            <span className="text-white/40 font-display font-bold text-xs uppercase">
              {name.charAt(0)}
            </span>
          </div>
        )}
        <span className="font-display font-bold uppercase text-white text-sm leading-none truncate max-w-[120px]">
          {name}
        </span>
      </div>

      {/* Set vinti */}
      {setsDisplay === 'number' ? (
        <div className={`flex items-center gap-2 ${isRight ? 'flex-row-reverse' : 'flex-row'}`}>
          <span className="text-white/45 font-display font-bold uppercase tracking-[0.2em] text-[10px]">Set</span>
          <span className="font-display font-bold tabular-nums text-2xl text-white leading-none">{setsWon}</span>
        </div>
      ) : (
        <div className={`flex gap-1 ${isRight ? 'flex-row-reverse' : 'flex-row'}`}>
          {Array.from({ length: 3 }, (_, i) => (
            <span
              key={i}
              className="w-3 h-3 rounded-full border border-white/30"
              style={{ backgroundColor: i < setsWon ? 'white' : 'transparent' }}
            />
          ))}
        </div>
      )}

      {/* Timeout */}
      <div className={`flex gap-1 ${isRight ? 'flex-row-reverse' : 'flex-row'}`}>
        {Array.from({ length: maxTimeouts }, (_, i) => (
          <span
            key={i}
            className="w-2 h-2 rounded-full border border-white/20"
            style={{ backgroundColor: i < timeoutsUsed ? '#FE7200' : 'transparent' }}
            title={i < timeoutsUsed ? 'Timeout usato' : 'Timeout disponibile'}
          />
        ))}
      </div>

      {/* Indicatore servizio */}
      {hasService && (
        <span className="text-[#FE7200] text-xs font-bold animate-pulse">▶</span>
      )}
    </div>
  )
}
